import React from 'react';
import styled, { css } from 'styled-components';
import JustificationContainer from '~/components/atom/JustificationContainer';
import FullWidthButton from '~/components/atom/FullWidthButton';
import { BaseAside } from '../../style';

export type Props = {
  disabled: boolean;
  loading: boolean;
  onSave: () => void;
  onCancel: () => void;
};

const FloatingSaveBar = React.forwardRef<HTMLElement, Props>(
  ({ onSave, onCancel, loading, disabled }, ref) => (
    <Container ref={ref}>
      <JustificationContainer
        width="100%"
        justification="space-between"
        gap="m"
      >
        <StyledButton
          label="Afbreken"
          onClick={onCancel}
          appearance="danger"
          ghost
          size="small"
          disabled={disabled}
        />
        <StyledButton
          label="Aanpassingen opslaan"
          onClick={onSave}
          appearance="secondary"
          icon="save"
          size="small"
          loading={loading}
          disabled={disabled}
        />
      </JustificationContainer>
    </Container>
  ),
);

const StyledButton = styled(FullWidthButton)(
  () => css`
    justify-content: center;
  `,
);

const Container = styled(BaseAside)<{}>(
  ({ theme }) => css`
    top: ${theme.space('s')};
    // Make sure it is always highest on the right side
    z-index: calc(${theme.getTokens().zIndex.dropdown} + 1);
    border-radius: ${theme.getTokens().border.radius.m};
  `,
);

export default FloatingSaveBar;
